import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import JobSearch from "../../Components/Jobseeker/JobSearch";

const JobSearchCareerPage = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <JobSearch marginTop={30} />
      </Container>
    </Fragment>
  );
};

export default JobSearchCareerPage;
